import { clientApi } from 'shared/api/clientApi'
import { refreshOrdersCount } from 'shared/api/orders-count-query'
import { Response } from 'shared/models/general.ts'

import { OrderBeket, ReserveSeats, ResponseReserveSeats } from './model'

export const OrderApiBeket = {
  reverseSeats(reserve: ReserveSeats) {
    return clientApi.post<Response<ResponseReserveSeats>>(
      `/bus/reserve-seats`,
      reserve,
    )
  },
  async updateOrderBeket(formBuy: OrderBeket) {
    const response = await clientApi.post<Response<ResponseReserveSeats>>(
      `/bus/update-order`,
      formBuy,
    )
    void refreshOrdersCount()
    return response
  },
}
